import { MutableRefObject } from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import InfoListItem from '~/components/InfoListItem';
import useFeature from '~/hooks/useFeature';

import RegionAccessInfo from '../../../../../../components/RegionAccessInfo';
import NameserverInfo from '../../../../components/NameserverInfo';
import SshAccessInfo from '../../../../components/SshAccessInfo';
import FtpAccessInfo from '../FtpAccessInfo';
import IPAddressInfo from '../IPAddressInfo';
import ResetPassword from '../ResetPassword';
import Wrapper from './Wrapper';

interface ServerInfoProps {
  container?: MutableRefObject<HTMLElement | null> | null;
  hasPurchasedRecently?: boolean;
}

const ServerInfo = ({
  container = null,
  hasPurchasedRecently = false,
}: ServerInfoProps) => {
  const { t } = useTranslation('site');
  const [isSites] = useFeature('sites');
  const isShared = isSites;

  const [isPlesk, plesk] = useFeature('plesk');
  const [isWindows, windows] = useFeature('windows');
  const [isReseller] = useFeature('reseller');

  /* @ts-ignore */
  const { nameservers } = t('quickConnect.items', { returnObjects: true });

  //hosting type reseller
  if (isReseller) {
    return (
      <Wrapper hasPurchasedRecently={hasPurchasedRecently}>
        <Grid container columns={12} display="flex">
          <Grid item xs={12} md={6} flexDirection="column">
            <InfoListItem
              key={nameservers?.id}
              title={nameservers?.label}
              tooltipText={nameservers?.tooltipText}
            >
              <NameserverInfo />
            </InfoListItem>
            <IPAddressInfo />
          </Grid>
        </Grid>
      </Wrapper>
    );
  }

  if (isPlesk || isWindows) {
    return (
      <Wrapper hasPurchasedRecently={hasPurchasedRecently}>
        <Grid container columns={12} display="flex">
          <Grid item xs={12} md={6} flexDirection="column" display="flex">
            <Typography variant="body2">
              <b>{t('advancedServer.username')}: </b>
              {plesk?.username || windows?.username}
            </Typography>
            <IPAddressInfo />
          </Grid>
          <Grid item xs={12} md={6} flexDirection="column" display="flex">
            <ResetPassword />
          </Grid>
        </Grid>
      </Wrapper>
    );
  }

  // shared
  if (isShared) {
    return (
      <Wrapper hasPurchasedRecently={hasPurchasedRecently}>
        <Grid container columns={12} display="flex">
          <Grid item xs={12} md={6} flexDirection="column">
            <InfoListItem
              key={nameservers?.id}
              title={nameservers?.label}
              tooltipText={nameservers?.tooltipText}
            >
              <NameserverInfo />
            </InfoListItem>
            <IPAddressInfo />
          </Grid>
          <Grid item xs={12} md={6} flexDirection="column" display="flex">
            <SshAccessInfo />
            <ResetPassword />
            <FtpAccessInfo />
            <RegionAccessInfo />
          </Grid>
        </Grid>
      </Wrapper>
    );
  }
};

export default ServerInfo;
